import { IoCall } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";
import "./styles.css";

function Footer() {
  return (
    <div className="footer-wrapper">
      <div className="footer-top">
        <div className="footer-right">
          <img src="./images/footer/hub-logo.png" alt="TD4PAI-logo" />
        </div>
          <a
            href="tel:+2349157727755"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-icon"
            aria-label="contact us via phone call"
          >
            <IoCall size={24} />
            +2349157727755
          </a>
          <a
            href="mailto:td4pai@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-icon"
            aria-label="contact us via email"
          >
            <MdMailOutline size={24} />
            td4pai@gmail.com
          </a>
      </div>
      <div className="copywright-wrapper">
        <h2>&copy; 2025</h2>
      </div>
    </div>
  );
}

export default Footer;
